import { Card } from "react-bootstrap";

const Services = () => (
  <Card bg="primary" text="white" className="text-center">
    <Card.Body>
      <Card.Title>
        <h1>Service Times</h1>
      </Card.Title>
      <Card.Text>Sunday 10:00 AM</Card.Text>
    </Card.Body>
  </Card>
);

export default Services;
